export function UserIcon() {
  return (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24 0C37.2548 0 48 10.7452 48 24C48 30.5548 45.3722 36.4959 41.1126 40.8273C37.3061 35.4838 31.0599 32 24 32C16.9401 32 10.6939 35.4838 6.88669 40.8261C2.62778 36.4959 0 30.5548 0 24C0 10.7452 10.7452 0 24 0ZM24 8C18.4772 8 14 12.4772 14 18C14 23.5228 18.4772 28 24 28C29.5228 28 34 23.5228 34 18C34 12.4772 29.5228 8 24 8Z" fill="var(--color-background-glassy-c)"/>
  </svg>
  );
}
